import { titleize } from '@/helpers/formatText'
import { Badge as BaseBadge, BadgeProps as BaseBadgeProps } from '../base/badge'

export type Role = {
  name: string
}

interface BadgeProps {
  role: Role
}

export const Badge = ({ role }: BadgeProps) => {
  const { name } = role
  let color: BaseBadgeProps['color'] = 'blue'
  switch (name) {
    case 'staff':
      color = 'green'
      break
    case 'crew':
      color = 'blue'
      break
  }

  return <BaseBadge color={color} data-testid="role-badge">{ titleize(name) }</BaseBadge>
}
